const messageStatuses = {
  DELIVERED: 2,
  FAILED: 99,
  NEW: 0,
  READ: 3,
  SENT: 1,
  WAITING: 98,
};

const conversationStatuses = {
  OPEN: 0,
  CLOSE: 1,
};

const messageTypes = {
  TEXT: 1,
  IMAGE: 2,
  AUDIO: 3,
  VIDEO: 4,
  DOCUMENT: 5,
  TEMPLATE: 6,
  LOCATION: 7,
  CONTACTS: 8,
  STICKER: 9,
  REACTION: 10,
  UNSUPPORT: 99,
  SYSTEM: [70, 71, 72, 73, 74, 75, 76],
};

const includeFileTypes = [
  messageTypes.IMAGE,
  messageTypes.AUDIO,
  messageTypes.VIDEO,
  messageTypes.DOCUMENT,
  messageTypes.STICKER,
];

const locale = {
  ID_ID: "id-ID",
  EN_US: "en-US",
};

const colorsMenu = [
  "#FDE3D9",
  "#ACDCEE",
  "#D9F489",
  "#FFE0A3",
  "#A5F0E4",
  "#E4D1D3",
  "#FFA1AC",
  "#F1E6D1",
  "#6FCF97",
];

const colorsIcon = [
  "#F47645",
  "#2D9CDB",
  "#219653",
  "#EB5757",
  "#2F80ED",
  "#9B51E0",
  "#6B7280",
  "#F47645",
  "#6B7280",
];

const colorsShortcut = [
  "bg-blue-400",
  "bg-purple-400",
  "bg-orange-400",
  "bg-orange-200",
  "bg-pink-400",
  "bg-yellow-400",
  "bg-red-400",
  "bg-green-400",
];

const colorsPrimary = [
  "#64748B",
  "#6B7280",
  "#71717A",
  "#737373",
  "#78716C",
  "#F97316",
  "#F59E0B",
  "#EAB308",
  "#84CC16",
  "#22C55E",
  "#10B981",
  "#14B8A6",
  "#06B6D4",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#A855F7",
  "#D946EF",
  "#EC4899",
  "#E53F6A",
  "#F43F5E",
  "#EF4444",
];

const randomColors = [
  "#6FCF97",
  "#F9AD8D",
  "#E4D1D3",
  "#F1E6D1",
  "#ACDCEE",
  "#A5F0E4",
  "#D9F489",
  "#FFA1AC",
  "#FFE0A3",
  "#F47645",
];

const randomColors2 = [
  "#FF6384",
  "#FFCD56",
  "#4BC0C0",
  "#36A2EB",
  "#CB99C9",
  "#EE82EE",
  "#FF2C63",
  "#00ADB5",
  "#08D9D6",
  "#F9ED69",
  "#F08A5D",
  "#B83B5E",
  "#6A2C70",
  "#FF2E63",
  "#112D4E",
  "#F38181",
  "#95E1D3",
  "#3F72AF",
  "#A8D8EA",
  "#AA96DA",
  "#FCBAD3",
  "#364F6B",
  "#3FC1C9",
  "#FC5185",
  "#0F4C75",
  "#3282B8",
  "#AD8B73",
  "#CEAB93",
  "#FF9494",
  "#CCA8E9",
  "#7D5A50",
  "#B4846C",
  "#967E76",
  "#30E3CA",
  "#11999E",
  "#40514E",
  "#F67280",
  "#C06C84",
  "#6C5B7B",
  "#355C7D",
  "#B1B2FF",
  "#E84545",
  "#903749",
  "#0D7377",
  "#14FFEC",
  "#99DDCC",
  "#769FCD",
  "#7895B2",
  "#E23E57",
  "#88304E",
  "#FFCFDF",
  "#8675A9",
  "#FF9292",
  "#7D6E83",
  "#9E7676",
  "#815B5B",
  "#594545",
  "#00B8A9",
  "#F6416C",
  "#FFDE7D",
  "#99A799",
  "#52616B",
  "#A8E6CF",
  "#BE9FE1",
  "#EA5455",
  "#2D4059",
];
const randomColors3 = [
  "#008FFB",
  "#00E396",
  "#FEAF1A",
  "#FE4560",
  "#775DD0",
  "#FFCC43",
  "#03C868",
  "#F88507",
  "#11FFAC",
  "#29C0FE",
];

const imageMimes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/tiff",
  "image/bmp",
  "image/webp",
  "image/x-icon",
];

const audioMimes = ["audio/mpeg", "audio/aac", "audio/amr", "audio/wav"];

const videoMimes = ["video/mp4", "video/x-msvideo", "video/x-matroska"];

const mediaMimes = [...imageMimes, ...videoMimes];

const documentMimes = [
  ...mediaMimes,
  ...audioMimes,
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
  "text/csv",
];

const MAX_FILE_SIZE = 10; // MB

const settingMenus = [
  {
    title: "Perusahaan",
    url: "/settings/company",
    icon: "company",
    group_id: 1,
    name: "company",
  },
  {
    title: "Billing",
    url: "/settings/billing",
    icon: "billing",
    group_id: 1,
    name: "billing",
  },
  {
    title: "Alur Bisnis",
    url: "/settings/businessflow",
    icon: "businessflow",
    group_id: 1,
    name: "businessflow",
  },
  {
    title: "Template",
    url: "/settings/template",
    icon: "setting_template",
    group_id: 1,
    name: "setting_template",
  },
  {
    title: "Profil",
    url: "/settings/profile",
    icon: "my_profile",
    group_id: 1,
    name: "profile",
  },
  {
    title: "Pengguna",
    url: "/settings/users",
    icon: "users",
    group_id: 1,
    name: "users",
  },
  {
    title: "Peran",
    url: "/settings/roles",
    icon: "roles",
    group_id: 1,
    name: "roles",
  },
  {
    title: "Tags",
    url: "/settings/tags",
    icon: "tags",
    group_id: 1,
    name: "tags",
  },
  {
    title: "Channel",
    url: "/settings/channels",
    icon: "channel",
    group_id: 1,
    name: "channel",
  },
  {
    title: "Open API",
    url: "/settings/apps",
    icon: "apps",
    group_id: 1,
    name: "apps",
  },
  {
    title: "Categories",
    url: "/settings/categories",
    icon: "",
    group_id: 1,
    name: "categories",
  },
];
const hiddenSettingMenus = [];

const imageExtention = ["jpeg", "jpg", "png", "tiff", "bmp", "webp", "x-icon"];
const videoExtention = ["mp4", "3gp", "avi", "mov", "mkv"];
const audioExtention = ["mp3", "aac", "wav", "ogg"];
const docExtention = ["doc", "docx"];
const xlsExtention = ["xls", "xlsx"];
const txtExtention = ["txt", "rtf"];
const pptExtention = ["ppt", "pptx"];

const showColumnsContactDefault = ["name", "company", "phone", "email"];
const ONLY_FOR_INTERNAL = [131624, 107471];
const ONLY_FOR_CRMKLEDO = [107471];

const transType = {
  MEETING_SCHEDULE_ADMIN_GROUP: 80,
  MEETING_SCHEDULE_ADMIN: 81,
  MEETING_SCHEDULE_WEEKDAY: 82,
  MEETING_SCHEDULE_WEEKEND: 83,
  MEETING_SCHEDULE: 84,
  MEETING_SCHEDULE_AVAILABILITY: 85,
};

const transTypeOtion = [
  {
    title: "Meeting Schedule Admin Group",
    id: 80,
  },
  {
    title: "Meeting Schedule Admin",
    id: 81,
  },
  {
    title: "Meeting Schedule Weekday",
    id: 82,
  },
  {
    title: "Meeting Schedule Weekend",
    id: 83,
  },
  {
    title: "Meeting Schedule",
    id: 84,
  },
  {
    title: "Meeting Schedule Availability",
    id: 85,
  },
];
const documentTemplateWAAccepted = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/plain",
];
const imageTemplateWAAccepted = ["image/jpeg", "image/png"];

const maxFileSizeDocumentTemplateAccepted = 10; // 100 MB https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#upload-media:~:text=16%20MB-,Document,-Document%20Type
const maxFileSizeImageTemplateAccepted = 5; // 5 MB https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#upload-media:~:text=16%20MB-,Document,-Document%20Type
//note: https://docs.google.com/document/d/1fjzTS_9ffnyu6s60HdW5FDIghCM5Je6ajbCx_8BdLRM/edit?tab=t.xugi6m97it0x

const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const textTypeSystemAgentRandom = [
  {
    // text: "mengambil conversation ID:",
    functionReplace: (text, textReplace = "") => {
      return text.replace(
        /agent\s+.*?(\s+mengambil conversation ID:)/g,
        `${textReplace}$1`,
      );
    },
  },
  {
    // text: "mengambil conversation ID:",
    functionReplace: (text, textReplace = "") => {
      let result = text;

      result = result.replace(
        /(dialihkan ke\s+).*?(\s+oleh)/g,
        `$1${textReplace}$2`,
      );
      if (result.includes("dialihkan")) {
        result = result.replace(/(\s+oleh\s+)(?!sistem).*$/g, `$1SESEORANG`);
      }

      return result;
    },
  },
  {
    // text: "mengambil conversation ID:",
    functionReplace: (text, textReplace = "") => {
      return text.replace(
        /(sistem memilih\s+).*?(\s+untuk menangani conversation ID:)/g,
        `$1${textReplace}$2`,
      );
    },
  },
  {
    // text: "mengambil conversation ID:",
    functionReplace: (text, textReplace = "") => {
      return text.replace(/(ditutup oleh\s+).*$/g, `$1${textReplace}`);
    },
  },
];
// "agent ". $agentName." mengambil conversation ID:$conversationId"
// "conversation ID:$conversationId dialihkan ke agent " . $agent->name . " oleh ". auth()->user()->name
// "sistem memilih agent " . $agent->name . " untuk menangani conversation ID:" . $conversationId
// "conversation ID:$conversationId ditutup oleh " . Auth::user()->name
// "conversation ID:" . $conversation->id . " masuk unassigned oleh sistem"
// "conversation ID:" . $conversation->id . " auto dialihkan ke agent " . $agent->name . " oleh sistem"
const baseUrl = `${import.meta.env.VITE_API_URL}/api/v1`;

const AI_STATUS = {
  ACCEPTED: 1,
  REJECTED: 0,
  EDITED: 2,
};

export {
  randomColors2,
  randomColors3,
  locale,
  colorsIcon,
  colorsMenu,
  colorsShortcut,
  colorsPrimary,
  messageStatuses,
  conversationStatuses,
  messageTypes,
  imageMimes,
  audioMimes,
  videoMimes,
  documentMimes,
  mediaMimes,
  randomColors,
  MAX_FILE_SIZE,
  includeFileTypes,
  settingMenus,
  imageExtention,
  videoExtention,
  audioExtention,
  docExtention,
  xlsExtention,
  txtExtention,
  pptExtention,
  hiddenSettingMenus,
  showColumnsContactDefault,
  ONLY_FOR_INTERNAL,
  transType,
  transTypeOtion,
  alphabets,
  textTypeSystemAgentRandom,
  documentTemplateWAAccepted,
  imageTemplateWAAccepted,
  maxFileSizeDocumentTemplateAccepted,
  maxFileSizeImageTemplateAccepted,
  baseUrl,
  ONLY_FOR_CRMKLEDO,
  AI_STATUS,
};
